// extracted by mini-css-extract-plugin
export var largeBtn = "CardCarousel-module--largeBtn--47aa8";